/**
 * Componente para exibir mensagem deletada (soft delete)
 * 
 * Renderiza placeholder visual "🚫 Mensagem apagada" similar ao WhatsApp,
 * mantendo o rastro de que existiu uma mensagem naquele ponto da conversa.
 */

import { Ban } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Database } from '@/integrations/supabase/types';

type MessageDirection = Database['public']['Enums']['message_direction'];

interface DeletedMessageBubbleProps {
  /** Direção da mensagem (inbound = recebida, outbound = enviada) */
  direction: MessageDirection;
  /** Horário formatado da mensagem original */
  time: string;
}

/**
 * Exibe placeholder para mensagem apagada estilo WhatsApp
 * Com ícone, texto em itálico e horário preservado
 */
export function DeletedMessageBubble({ direction, time }: DeletedMessageBubbleProps) {
  return (
    <div
      className={cn(
        'rounded-2xl px-4 py-2 max-w-[70%]',
        direction === 'outbound'
          ? 'rounded-br-md'
          : 'rounded-bl-md'
      )}
      style={{
        backgroundColor: direction === 'outbound' 
          ? 'hsl(var(--chat-bubble-outbound))' 
          : 'hsl(var(--chat-bubble-inbound))',
      }}
    >
      {/* Conteúdo da mensagem deletada */}
      <div className="flex items-center gap-2">
        <Ban 
          className="h-4 w-4 flex-shrink-0"
          style={{ color: 'hsl(var(--chat-text-secondary))' }}
        />
        <span
          className="text-sm italic"
          style={{ color: 'hsl(var(--chat-text-secondary))' }}
        >
          Mensagem apagada
        </span>
      </div>
      
      {/* Horário */}
      <div
        className={cn(
          'flex mt-1',
          direction === 'outbound' ? 'justify-end' : 'justify-start'
        )}
      >
        <span
          className="text-[10px]"
          style={{ color: 'hsl(var(--chat-text-secondary))' }}
        >
          {time}
        </span>
      </div>
    </div>
  );
}
